import XpCard from "./XpCard";
import data from "../xp.json"
import "../styles/Xp.css"
const Xp = (props) => {
    const xpArray = data.xp
    console.log(xpArray)
    return (
        <div>
            <h1 className="xpxpxp"/>
            <h1 ref = {props.refProp} className="title">Experiences</h1>
        <div className="xp-container" >
            {xpArray.map(e => (
                <XpCard key={e.Id}
                    Id={e.Id}
                    Name={e.Name}
                    Details={e.Details}
                    Link={e.Link}
                    Skills= {e.Skills}
                    Company={e.Company}
                    Date={e.Date}
                    Intro={e.Intro}
                />
            ))}
        </div>
        </div>
    )
}

export default Xp